/**
 * Image URLs and asset constants
 * Centralized location for all external image URLs used in the application
 */

export const IMAGE_URLS = {
  ABOUT_US_EVENT_CELEBRATION:
    'https://images.squarespace-cdn.com/content/v1/5a5b3f862278e73ef37fb701/0d460e04-1810-4db3-8507-604995340088/fill-the-dance-floor-at-your-wedding.jpg?format=1000w',
  /** Event Phone Line illustration on landing; reused for concierge card + in-app chatbot avatar */
  LANDING_AGENT_ILLUSTRATION:
    'https://images.squarespace-cdn.com/content/v1/5a5b3f862278e73ef37fb701/3ae87bcf-0017-4279-9fe6-dd405fbf6f23/phone-04.png?format=500w',
} as const;

